import React from 'react';
import { Alert, Card, Progress, Row, Space, Typography, } from 'antd';
import 'react-phone-input-2/lib/style.css';
import { DocumentProps } from "../../types/types";
import documentTextOutline from "../../assets/images/document-text-outline.svg";
import { RightOutlined } from '@ant-design/icons';


const { Title, Text } = Typography;

export const AllDocuments: React.FC<{
  progressRequired: number,
  progressAdditional: number,
  uploadedRequired: DocumentProps[],
  uploadedAdditional: DocumentProps[],
  listOfRequiredDocuments: DocumentProps[],
  listOfAdditionalDocuments: DocumentProps[],
  setShowRequiredDocuments: (show: boolean) => void,
  setShowAdditionalDocuments: (show: boolean) => void,

}> = ( props ) => {
  const {
    progressRequired,
    uploadedRequired,
    uploadedAdditional,
    progressAdditional,
    listOfRequiredDocuments,
    listOfAdditionalDocuments,
    setShowRequiredDocuments,
    setShowAdditionalDocuments
  } = props;

  return (
    <Space direction={'vertical'} size={'large'} className={'full-width'}>
      <Card onClick={() => setShowRequiredDocuments?.(true)} style={{padding: '20px', borderRadius: '6px', cursor: 'pointer'}}>
        <Space direction={'vertical'} size={'middle'} className={'full-width'}>
          <Row justify={'space-between'}>
            <img
              alt="Icon"
              src={documentTextOutline}
              style={{ height: '25px', width: '25px' }}
            />
            <RightOutlined style={{ fontSize: '20px' }}/>
          </Row>
          <Space direction={'vertical'} size={'small'}>
            <Title style={{ margin: 0 }} level={5}>
              Required documents
            </Title>
            <Text>You will need to upload these documents to progress.</Text>
          </Space>
          <Space.Compact direction={'vertical'} size={'small'} style={{ width: '80%' }}>
            <Progress percent={progressRequired}
                      showInfo={false}
                      strokeColor="#FF930F"/>
            <Text type={'secondary'}>{uploadedRequired?.length}/{listOfRequiredDocuments?.length} documents</Text>
          </Space.Compact>
        </Space>
      </Card>

      <Alert
        message={'As your business is X we recommend uploading some additional documents to speed up your application.'}
        type={'warning'}
        style={{ borderRadius: '8px' }}/>

      <Card onClick={() => setShowAdditionalDocuments?.(true)} style={{padding: '20px', borderRadius: '6px', cursor: 'pointer'}}>
        <Space direction={'vertical'} size={'middle'} className={'full-width'}>
          <Row justify={'space-between'}>
            <img
              alt="Icon"
              src={documentTextOutline}
              style={{ height: '25px', width: '25px' }}
            />
            <Space direction={'horizontal'} size={'middle'}>
              <Text type={'secondary'}>Optional</Text>
              <RightOutlined style={{ fontSize: '20px' }}/>
            </Space>
          </Row>
          <Space direction={'vertical'} size={'small'}>
            <Title style={{ margin: 0 }} level={5}>
              Additional documents
            </Title>
            <Text>These documents aren't required but will help your progress.</Text>
          </Space>
          <Space.Compact direction={'vertical'} size={'small'} style={{ width: '80%' }}>
            <Progress percent={progressAdditional}
                      showInfo={false}
                      strokeColor="#FF930F"/>
            <Text
              type={'secondary'}>{uploadedAdditional?.length}/{listOfAdditionalDocuments?.length} documents</Text>
          </Space.Compact>
        </Space>
      </Card>
    </Space>
  );
};
